import React from 'react';
import { layout } from 'styled-system';
import styled from '@emotion/styled';
import { Text, Box, Flex } from 'rebass';
import { BsSoundwave } from "react-icons/bs";

const DisplayBox = styled.div`
${layout};
margin:auto;
`;

const ActionItems = React.forwardRef(
    ({ icon, iconSize, isSelected, label, children, size, labelProps, selected, nextIcon = false, ...props }, ref) => {

        const iconcolor = isSelected ? '#fff' : "#64748B";
        const labelColor = isSelected ? '#fff' : "#766AB9";
        return (
            <Flex ref={ref} sx={{ cursor:'pointer' }} {...props} justifyContent="space-between" width="100%" alignItems="center">
                <Flex alignItems="center">
                    <Flex height="max-content" mr={1} justifyContent="center" alignItems="center" bg="#FAEBFF" p="14px" sx={{ borderRadius: '50%' }}>
                        <Box as={BsSoundwave} color="#B568CF" minWidth={24} size={24} />
                    </Flex>
                    <Text fontFamily="Poppins" fontSize={18} lineHeight="165%" fontWeight={500} color="#0E0E0E" >
                        Voice Recording
                    </Text>
                </Flex>
                <svg xmlns="http://www.w3.org/2000/svg" width="9" height="16" viewBox="0 0 9 16" fill="none">
                    <path d="M0.514648 2.34292L1.92885 0.928711L8.99995 7.99975L1.92885 15.0709L0.514648 13.6567L6.17155 7.99975L0.514648 2.34292Z" fill="#64748B" />
                </svg>
            </Flex>

            // <Button
            //     variant="transparent"
            //     type="button"
            //     color="white"
            //     // style={{ }}
            //     css="display: flex; justify-content: center; align-items: center;"
            //     sx={{
            //         minHeight: size, minWidth: size,
            //         width: '100%',
            //         maxWidth: 320,
            //         borderRadius: 200,
            //         backgroundColor: 'rgba(0, 0, 0, 0.5)',
            //         border: '1px solid',
            //         borderColor: labelColor,
            //         fontWeight: 'normal',
            //     }}
            //     p={'16px'}
            //     px={'20px'}
            //     ref={ref}
            //     bg={isSelected ? "#53F" : "#fff"}
            //     {...props}
            // >
            //     <Box pl={3} mr={1} as={icon} color={iconcolor} size={iconSize} width="auto" />
            //     {label && (
            //         <DisplayBox mr={1} display={['inline-block']} m="auto">
            //             <Text color={labelColor} px={1} fontSize={1}>
            //                 {label}
            //             </Text>
            //         </DisplayBox>
            //     )}
            //     {nextIcon && <Box as={FaArrowRight} color={iconcolor} size={iconSize} />}
            // </Button>
        );
    }
);

export default ActionItems